<template>
  <div class="device-dashboard">
    <!-- Header -->
    <!--
      <VCard
      color="primary"
      class="rounded-0"
      elevation="0"
      >
      <VCardText class="pa-6 text-center">
      <VIcon
      icon="tabler-device-desktop"
      size="56"
      class="mb-3"
      />
      <h1 class="text-h4 font-weight-bold mb-2">
      Device Management
      </h1>
      <p class="text-body-1 mb-0">
      Select an action to continue
      </p>
      </VCardText>
      </VCard> 
    -->

    <!-- Content -->
    <VContainer
      fluid
      class="pa-6"
    >
      <VRow justify="center">
        <VCol
          cols="12"
          md="10"
          lg="8"
        >
          <!-- Device Information Card -->
          <VCard
            elevation="3"
            class="mb-6"
          >
            <VCardTitle class="bg-grey-lighten-4 d-flex align-center pa-4">
              <VIcon
                icon="tabler-device-ipad"
                class="me-2"
              />
              Device Information
            </VCardTitle>
            <VCardText class="pa-6">
              <VRow>
                <VCol
                  cols="12"
                  sm="6"
                >
                  <div class="info-item mb-4">
                    <div class="d-flex align-center mb-2">
                      <VIcon
                        icon="tabler-id"
                        size="20"
                        color="primary"
                        class="me-2"
                      />
                      <span class="text-caption text-medium-emphasis">Device Name</span>
                    </div>
                    <p class="text-h6 font-weight-bold mb-0">
                      {{ deviceInfo.name || 'N/A' }}
                    </p>
                  </div>
                </VCol>

                <VCol
                  cols="12"
                  sm="6"
                >
                  <div class="info-item mb-4">
                    <div class="d-flex align-center mb-2">
                      <VIcon
                        icon="tabler-map-pin"
                        size="20"
                        color="primary"
                        class="me-2"
                      />
                      <span class="text-caption text-medium-emphasis">Location</span>
                    </div>
                    <p class="text-h6 font-weight-bold mb-0">
                      {{ deviceInfo.visitor_location?.name || 'N/A' }}
                    </p>
                  </div>
                </VCol>

                <VCol
                  cols="12"
                  sm="6"
                >
                  <div class="info-item mb-4">
                    <div class="d-flex align-center mb-2">
                      <VIcon
                        icon="tabler-network"
                        size="20"
                        color="primary"
                        class="me-2"
                      />
                      <span class="text-caption text-medium-emphasis">Kiosk Type</span>
                    </div>
                    <p class="text-h6 font-weight-bold mb-0 text-capitalize">
                      {{ deviceInfo.kiosk_type || 'N/A' }}
                    </p>
                  </div>
                </VCol>

                <VCol
                  cols="12"
                  sm="6"
                >
                  <div class="info-item mb-4">
                    <div class="d-flex align-center mb-2">
                      <VIcon
                        icon="tabler-device-laptop"
                        size="20"
                        color="primary"
                        class="me-2"
                      />
                      <span class="text-caption text-medium-emphasis">Status</span>
                    </div>
                    <p class="text-h6 font-weight-bold mb-0 text-capitalize">
                      {{ deviceInfo.status || 'N/A' }}
                    </p>
                  </div>
                </VCol>
              </VRow>

              <VDivider class="my-4" />

              <!-- Device Status -->
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <VIcon
                    icon="tabler-activity"
                    size="20"
                    color="success"
                    class="me-2"
                  />
                  <span class="text-body-2">Last Heartbeat: {{ deviceHeartbeat?.last_heartbeat ? moment(deviceHeartbeat.last_heartbeat).format('YYYY-MM-DD HH:mm:ss') : 'N/A' }}</span>
                </div>
                <VChip
                  :color="deviceHeartbeat?.status ? 'success' : 'error'"
                  size="small"
                  :prepend-icon="deviceHeartbeat?.status ? 'tabler-circle-check' : 'tabler-exclamation-circle'"
                >
                  {{ deviceHeartbeat?.status ? 'Online' : 'Offline' }}
                </VChip>
              </div>
            </VCardText>
          </VCard>

          <!-- Action Buttons -->
          <VCard elevation="3">
            <VCardTitle class="bg-grey-lighten-4 pa-4">
              <VIcon
                icon="tabler-hand-click"
                class="me-2"
              />
              Select Action
            </VCardTitle>
            <VCardText class="pa-6">
              <VRow>
                <VCol
                  cols="12"
                  md="6"
                >
                  <VCard
                    class="action-card check-in-card border"
                    variant="outlined"
                    hover
                    @click="goToCheckIn"
                  >
                    <VCardText class="pa-8 text-center">
                      <VIcon
                        icon="tabler-door-enter"
                        size="50"
                        color="primary"
                        class="mb-4"
                      />
                      <h2 class="text-h4 font-weight-bold mb-2">
                        Check In
                      </h2>
                      <p class="text-body-2 text-medium-emphasis mb-0">
                        Scan visitor QR code for entry
                      </p>
                    </VCardText>
                  </VCard>
                </VCol>

                <VCol
                  cols="12"
                  md="6"
                >
                  <VCard
                    class="action-card check-out-card border"
                    variant="outlined"
                    hover
                    @click="goToCheckOut"
                  >
                    <VCardText class="pa-8 text-center">
                      <VIcon
                        icon="tabler-door-exit"
                        size="50"
                        color="primary"
                        class="mb-4"
                      />
                      <h2 class="text-h4 font-weight-bold mb-2">
                        Check Out
                      </h2>
                      <p class="text-body-2 text-medium-emphasis mb-0">
                        Scan visitor QR code for exit
                      </p>
                    </VCardText>
                  </VCard>
                </VCol>
              </VRow>
            </VCardText>
          </VCard>

          <!-- Quick Stats -->
          <!--
            <VCard
            elevation="3"
            class="mt-6"
            >
            <VCardTitle class="bg-grey-lighten-4 pa-4">
            <VIcon
            icon="tabler-chart-bar"
            class="me-2"
            />
            Today's Activity
            </VCardTitle>
            <VCardText class="pa-6">
            <VRow>
            <VCol
            cols="6"
            sm="3"
            >
            <div class="text-center">
            <VIcon
            icon="tabler-users"
            size="32"
            color="info"
            class="mb-2"
            />
            <h3 class="text-h5 font-weight-bold mb-1">
            {{ stats.total_visitors }}
            </h3>
            <p class="text-caption text-medium-emphasis mb-0">
            Total Visitors
            </p>
            </div>
            </VCol>

            <VCol
            cols="6"
            sm="3"
            >
            <div class="text-center">
            <VIcon
            icon="tabler-door-enter"
            size="32"
            color="success"
            class="mb-2"
            />
            <h3 class="text-h5 font-weight-bold mb-1">
            {{ stats.check_ins }}
            </h3>
            <p class="text-caption text-medium-emphasis mb-0">
            Check-Ins
            </p>
            </div>
            </VCol>

            <VCol
            cols="6"
            sm="3"
            >
            <div class="text-center">
            <VIcon
            icon="tabler-door-exit"
            size="32"
            color="warning"
            class="mb-2"
            />
            <h3 class="text-h5 font-weight-bold mb-1">
            {{ stats.check_outs }}
            </h3>
            <p class="text-caption text-medium-emphasis mb-0">
            Check-Outs
            </p>
            </div>
            </VCol>

            <VCol
            cols="6"
            sm="3"
            >
            <div class="text-center">
            <VIcon
            icon="tabler-clock"
            size="32"
            color="primary"
            class="mb-2"
            />
            <h3 class="text-h5 font-weight-bold mb-1">
            {{ stats.current_visitors }}
            </h3>
            <p class="text-caption text-medium-emphasis mb-0">
            Currently Inside
            </p>
            </div>
            </VCol>
            </VRow>
            </VCardText>
            </VCard> 
          -->

          <VBtn
            color="error"
            class="mt-6"
            block
            @click="onResetDevice"
          >
            Reset Device
          </VBtn>
        </VCol>
      </VRow>
    </VContainer>
  </div>
</template>

<script setup>
import { kioskAuthState } from '@/@core/auth/kioskAuthState'
import { useToast } from '@/composables/useToast'
import moment from 'moment'
import { useRouter } from 'vue-router'

// Composables
const router = useRouter()
const snackbar = useToast()

// Define page metadata
definePage({
  meta: {
    layout: 'blank',
    public: true,
    unauthenticatedOnly: true,
    title: 'Device Panel',
  },
})

const auth = kioskAuthState()

// Page Accessability Checking
if (!auth.token) {
  router.push({
    name: 'care-visit-kiosk-registration',
  })
}

const { 
  data: deviceInfo,
} = await useApi(createUrl("/care-visit/kiosk/information"), {
  beforeFetch: ({ cancel }) => {
    if (!auth.token) cancel()
  },
})

const deviceHeartbeat = ref()

// Device information (get from localStorage or session)
// const deviceInfo = ref({
//   device_id: localStorage.getItem('device_id') || 'KIOSK-001',
//   location: localStorage.getItem('location_code') || 'Main Entrance',
//   ip_address: localStorage.getItem('ip_address') || '192.168.1.100',
//   session_id: localStorage.getItem('session_id') || 'SESSION-' + Date.now(),
// })

// * Device Information API Call
// ----

// Statistics
const stats = ref({
  total_visitors: 0,
  check_ins: 0,
  check_outs: 0,
  current_visitors: 0,
})

// Methods
const goToCheckIn = () => {
  router.push({ name: 'care-visit-kiosk-check-in' })
}

const goToCheckOut = () => {
  router.push({ name: 'care-visit-kiosk-check-out' })
}

const fetchStats = async () => {
  try {
    // TODO: Replace with actual API endpoint
    // const response = await $api('/care-visit/devices/stats', {
    //   params: {
    //     device_id: deviceInfo.value.device_id,
    //   },
    // })

    // Simulated stats
    stats.value = {
      total_visitors: 45,
      check_ins: 23,
      check_outs: 22,
      current_visitors: 1,
    }
  } catch (error) {
    console.error('Error fetching stats:', error)
  }
}

const onResetDevice = () => {
  auth.setToken(null)

  router.push({
    name: 'care-visit-kiosk-registration',
  })
}

// * Call Heartbeat API In Every 5 Minutes
const heartbeat = () => {
  $api('/care-visit/kiosk/heartbeat', {
    method: 'POST',
  }).then(({ server_time }) => {
    deviceHeartbeat.value = {
      status: true,
      last_heartbeat: server_time,
    }
  }).catch(error => {
    deviceHeartbeat.value.status = false
  })
}

// Lifecycle
onMounted(() => {
  // Check Heartbeat
  heartbeat()
  setInterval(() => {
    heartbeat()
  }, 300000)

  console.log('✅ Device dashboard mounted')
  console.log('📱 Device info:', deviceInfo.value)

  // Fetch today's statistics
  fetchStats()
})
</script>

<style scoped>
.device-dashboard {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-block-size: 100vh;
}

.info-item {
  border-inline-start: 3px solid rgb(var(--v-theme-primary));
  padding-inline-start: 1rem;
}

.action-card {
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 15%) !important;
  transform: translateY(-4px);
}

.check-in-card:hover {
  border-color: rgb(var(--v-theme-success));
}

.check-out-card:hover {
  border-color: rgb(var(--v-theme-warning));
}

.text-medium-emphasis {
  opacity: 0.68;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .action-card {
    margin-block-end: 1rem;
  }
}
</style>
